"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Members = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _GroupAddMembersModal = _interopRequireDefault(require("./../../GroupAddMembersModal"));

var _GroupRemoveMemberModal = _interopRequireDefault(require("./../../GroupRemoveMemberModal"));

var _GroupMemberItem = require("./../../GroupMemberItem");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SearchBox = _interopRequireDefault(require("@insided/deprecated-preact-components/search-box/SearchBox"));

var _Pagination = _interopRequireDefault(require("@insided/shared/uikit/Pagination"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _toKebabCase = require("@insided/shared/utils/toKebabCase");

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _service = require("./../../service");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_CURRENT_PAGE = 1;
var DEFAULT_PAGE_SIZE = 25;

var Members = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Members, _Component);

  var _super = _createSuper(Members);

  function Members() {
    var _this;

    (0, _classCallCheck2.default)(this, Members);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      searchValue: '',
      showAddMembersModal: false,
      showRemoveMemberModal: false,
      memberToRemove: null,
      members: [],
      membersTotal: null,
      currentPage: DEFAULT_CURRENT_PAGE,
      totalPagesCount: null,
      showMessage: false,
      messageStatus: 'success',
      messageText: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchUsers(DEFAULT_CURRENT_PAGE);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mapUsers", function (members) {
      return members.map(function (member) {
        return {
          id: "".concat(member.id),
          name: member.username,
          avatar: member.avatar,
          url: "/members/".concat((0, _toKebabCase.textToKebab)(member.username), "-").concat(member.id),
          userTitle: member.member_status
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchUsers", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(page, searchString) {
        var _yield$fetchMembers, members, total;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return (0, _service.fetchMembers)({
                  groupId: _this.props.group.id,
                  page: page,
                  pageSize: DEFAULT_PAGE_SIZE,
                  searchString: searchString
                });

              case 3:
                _yield$fetchMembers = _context2.sent;
                members = _yield$fetchMembers.members;
                total = _yield$fetchMembers.total;

                _this.setState({
                  members: _this.mapUsers(members),
                  membersTotal: total,
                  currentPage: page,
                  totalPagesCount: Math.ceil(total / DEFAULT_PAGE_SIZE)
                });

                _context2.next = 11;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 9]]);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNextPage", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.fetchUsers(_this.state.currentPage + 1);

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPreviousPage", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this.fetchUsers(_this.state.currentPage - 1);

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSearchInput", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(e) {
        var value;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                value = e.target.value;

                _this.setState({
                  searchValue: value
                });

                _context5.next = 4;
                return _this.fetchUsers(DEFAULT_CURRENT_PAGE, value);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSearch", (0, _debounce.default)( /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(e) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this.onSearchInput(e);

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }(), 500));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearSearch", /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(e) {
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                e.stopPropagation();

                _this.setState({
                  searchValue: ''
                });

                _context7.next = 4;
                return _this.fetchUsers(DEFAULT_CURRENT_PAGE);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x5) {
        return _ref7.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "openAddMembersModal", function () {
      _this.setState({
        showAddMembersModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "openRemoveMemberModal", function (id) {
      _this.setState({
        showRemoveMemberModal: true,
        memberToRemove: id
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Members, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var group = this.props.group;
      var _this$state = this.state,
          searchValue = _this$state.searchValue,
          members = _this$state.members,
          membersTotal = _this$state.membersTotal,
          showAddMembersModal = _this$state.showAddMembersModal,
          showRemoveMemberModal = _this$state.showRemoveMemberModal,
          memberToRemove = _this$state.memberToRemove,
          totalPagesCount = _this$state.totalPagesCount,
          currentPage = _this$state.currentPage,
          showMessage = _this$state.showMessage,
          messageStatus = _this$state.messageStatus,
          messageText = _this$state.messageText;
      return (0, _preact.h)("div", {
        className: "group-moderation__members"
      }, (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "group-moderation__main__header"
      }, (0, _preact.h)("div", {
        className: "group-moderation__main__header__title"
      }, (0, _preact.h)("span", {
        className: "group-moderation__main__header__title__main"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.group.members"
      })), (0, _preact.h)("span", null, "\u2022"), (0, _preact.h)("span", {
        className: "group-moderation__main__header__title__count"
      }, membersTotal, " ", (0, _preact.h)(_phrase.default, {
        p: "groups.users"
      }))), (0, _preact.h)(_Button.default, {
        size: "medium",
        className: "group-moderation__main__header__button",
        onClick: this.openAddMembersModal,
        "data-bounded-context": "Groups",
        "data-entity": "group-members",
        "data-track-type": "click",
        "data-element-name": "Group Clicked add members"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.add"
      }))), (0, _preact.h)("div", {
        className: "group-moderation__main__search"
      }, (0, _preact.h)(_SearchBox.default, {
        isModerationOverview: true,
        placeholder: "Search for group members...",
        value: searchValue,
        onSubmit: function onSubmit() {},
        onInput: this.handleSearch,
        onClear: this.onClearSearch,
        iconSize: 24
      })), (0, _preact.h)("div", {
        className: "group-moderation__main__members"
      }, members.map(function (member) {
        return (0, _preact.h)(_GroupMemberItem.GroupMember, {
          key: member.id,
          member: member,
          disablePopup: true,
          isModeration: true,
          onRemoveMember: _this2.openRemoveMemberModal
        });
      })), (0, _preact.h)("div", {
        className: "group-moderation__main__footer"
      }, members.length ? (0, _preact.h)("div", null, (0, _preact.h)(_Button.default, {
        size: "medium",
        onClick: this.onPreviousPage,
        className: (0, _classnames.default)('btn', 'btn--secondary', 'group-moderation__main__footer__previous', {
          hidden: currentPage === DEFAULT_CURRENT_PAGE
        })
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.previous"
      })), (0, _preact.h)("div", {
        className: "group-moderation__main__footer__pages"
      }, totalPagesCount && totalPagesCount > 1 ? (0, _preact.h)(_Pagination.default, {
        totalPageCount: totalPagesCount,
        currentPage: currentPage,
        generateNewUrl: function generateNewUrl() {
          return '';
        },
        onPageClick: /*#__PURE__*/function () {
          var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(e, i) {
            return _regenerator.default.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    e.preventDefault();
                    _context8.next = 3;
                    return _this2.fetchUsers(i);

                  case 3:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8);
          }));

          return function (_x6, _x7) {
            return _ref8.apply(this, arguments);
          };
        }()
      }) : null), (0, _preact.h)(_Button.default, {
        size: "medium",
        onClick: this.onNextPage,
        className: (0, _classnames.default)('btn', 'btn--secondary', 'group-moderation__main__footer__next', {
          hidden: currentPage === totalPagesCount
        })
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.next"
      }))) : null)), showAddMembersModal ? (0, _preact.h)(_GroupAddMembersModal.default, {
        groupId: group.id,
        onClose: function onClose() {
          return _this2.setState({
            showAddMembersModal: false
          });
        },
        onAdd: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
          return _regenerator.default.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return _this2.fetchUsers(DEFAULT_CURRENT_PAGE);

                case 2:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        })),
        showMessage: function showMessage(status, message) {
          return _this2.setState({
            showMessage: true,
            messageStatus: status,
            messageText: message
          });
        },
        communityLocale: this.props.communityLocale
      }) : null, showRemoveMemberModal ? (0, _preact.h)(_GroupRemoveMemberModal.default, {
        groupTitle: group.name,
        groupId: group.id,
        memberId: memberToRemove,
        onRemove: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
          return _regenerator.default.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return _this2.fetchUsers(currentPage);

                case 2:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        })),
        onClose: function onClose() {
          return _this2.setState({
            showRemoveMemberModal: false
          });
        },
        showMessage: function showMessage(status, message) {
          return _this2.setState({
            showMessage: true,
            messageStatus: status,
            messageText: message
          });
        }
      }) : null, showMessage ? (0, _preact.h)(_message.default, {
        variant: messageStatus,
        onDismiss: function onDismiss() {
          return _this2.setState({
            showMessage: false
          });
        },
        timer: 5000
      }, messageText) : null);
    }
  }]);
  return Members;
}(_preact.Component);

exports.Members = Members;
var _default = Members;
exports.default = _default;